import { render, staticRenderFns } from "./UserTagList.vue?vue&type=template&id=6a006fc9&scoped=true"
import script from "./UserTagList.vue?vue&type=script&lang=js"
export * from "./UserTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a006fc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a006fc9')) {
      api.createRecord('6a006fc9', component.options)
    } else {
      api.reload('6a006fc9', component.options)
    }
    module.hot.accept("./UserTagList.vue?vue&type=template&id=6a006fc9&scoped=true", function () {
      api.rerender('6a006fc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/user/UserTagList.vue"
export default component.exports